import * as Yup from 'yup';

export const houseSchema = Yup.object().shape({
  name: Yup.string().required(),
  address: Yup.string().required().max(100).min(2),
  postcode: Yup.string().required().max(4).min(4),
  city: Yup.string().required().max(50).min(2)
});
